import styled from 'styled-components';

const S = {};

S.Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
`;

S.StreamIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  
  svg {
    width: 100%;
    height: 100%;
  }
  
  &:hover {
    opacity: 0.8;
  }
`;

S.PlayerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  border-radius: 1rem;
  overflow: hidden;
`;

S.PlayerHost = styled.div`
  width: 100%;
  height: 100%;
  background: #000;
  position: relative;
  
  /* Upewnij się że wideo wypełnia cały kontener */
  & > div {
    width: 100% !important;
    height: 100% !important;
  }
  
  video {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
  }
`;

S.ErrorBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(27, 27, 27, 0.95);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  z-index: 10;
`;

S.ErrorMessage = styled.div`
  color: #fff;
  font-size: 12px;
  flex: 1;
`;

S.PlayerControls = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  gap: 4px;
  z-index: 10;
`;

S.ControlButton = styled.button`
  background: rgba(0, 0, 0, 0.7);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  touch-action: manipulation;
  
  &:hover,
  &:active {
    background: rgba(0, 0, 0, 0.9);
  }
  
  svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }
`;

S.LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 20px;
`;

export default S;
